import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ACTIVITY_SUBJECT } from "@offsilo/contracts/activities";
import { CallsPage } from "@/features/calls/CallsPage";

// ?dial=<number>&st=<contact|deal|client|lead>&sid=<record id> opens the dialer on a record (click-to-call)
const search = z.object({
  dial: z.string().optional(),
  st: ACTIVITY_SUBJECT.optional(),
  sid: z.string().optional(),
});

export const Route = createFileRoute("/_app/calls/")({
  validateSearch: search,
  component: () => <CallsPage search={Route.useSearch()} />,
});
